
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("9U2Pr", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsContentViewQuery", () => $95aeb2e2a706cad0$export$d2a0f618d39814a6);

var $gy8uL = parcelRequire("gy8uL");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $DCnR7 = parcelRequire("DCnR7");
function $95aeb2e2a706cad0$export$d2a0f618d39814a6({ queries: { projects: projects } }) {
    const data = (0, $j4oe4.usePreloadedQuery)((0, $gy8uL.default), projects);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $DCnR7.Nav4ProjectsContent), {
        queryRef: data
    });
}

});


//# sourceMappingURL=async-nav4-projects-content-view-query.1c86d210.js.map
